import { DialogService } from './../../../../../../../libs/core/src/lib/services/dialog.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'concourse-shared-request',
  templateUrl: './shared-request.component.html',
  styleUrls: ['./shared-request.component.scss']
})
export class SharedRequestComponent implements OnInit {

  sessionId = null;
  constructor(
    private activateRouted: ActivatedRoute,
    private router: Router) { }

  ngOnInit(): void {
    this.activateRouted.queryParams.subscribe((result) => {
      if (result && result['sessionId']) {
        this.sessionId = result['sessionId'] || null;
      } else {
        this.router.navigate(["/"])
      }
    });
  }

}
